import React, { Fragment, useState, useEffect } from "react";

import classnames from "classnames";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { fetchFacilities } from "../../../actions/facility";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Label,
  Input,
  Form,
} from "reactstrap";

import "eva-icons/style/eva-icons.css";

const AddEventSidebar = (props) => {
  const {
    store,
    dispatch: propDispatch,
    open,
    handleAddMessage,
    refetchMessages,
    addMessage,
    selectMessage,
    updateMessage,
  } = props;

  const dispatch = useDispatch();
  const facilitiesData = useSelector(state => state.facilities.facilities || []);
  const selectedMessage = store.selectedMessage;
  const { register, errors, handleSubmit } = useForm();

  const [note, setNote] = useState("");
  const [facility_id, setFacilityID] = useState("");
//  const [building_id, setBuildingID] = useState("");
//  const [group_id, setGroupID] = useState("");
//  const [unit_id, setUnitID] = useState("");
  const [assignedDate, setAssignedDate] = useState(new Date());
  const [assignedTo, setAssignedTo] = useState("");
  const [maintenance_type, setMaintenanceType] = useState("");
  const [facility_name, setFacilityName] = useState("");

  useEffect(() => {
    dispatch(fetchFacilities());
  }, [dispatch]);

  const isObjEmpty = (obj) => Object.keys(obj).length === 0;

  const handleAddEvent = () => {
    // const selectedFacility = facilitiesData.find(f => f.id === facility_id);
    const obj = {
      note,
      facility_id,
//       building_id,
//       group_id,
//       unit_id,
      assignedDate,
      assignedTo,
      maintenance_type,
      facility_name: facilitiesData.find(f => f.id === facility_id)?.name || null,
    };
    propDispatch(addMessage(obj));
    refetchMessages();
    handleAddMessage();
  };

  const handleSelectedEvent = () => {
    if (!isObjEmpty(selectedMessage)) {
      setNote(selectedMessage.note || note);
      setFacilityID(selectedMessage.facility_id || facility_id);
      setFacilityName(selectedMessage.facility_name || facility_name);
//       setBuildingID(selectedMessage.building_id || building_id);
//       setGroupID(selectedMessage.group_id || group_id);
//       setUnitID(selectedMessage.unit_id || unit_id);
      setAssignedDate(selectedMessage.assignedDate || assignedDate);
      setAssignedTo(selectedMessage.assignedTo || assignedTo);
      setMaintenanceType(selectedMessage.maintenance_type || maintenance_type);
    }
  };

  const handleResetInputValues = () => {
    propDispatch(selectMessage({}));

    setNote("");
    setFacilityID("");
    // setBuildingID("");
    // setGroupID("");
    // setUnitID("");
    setAssignedDate("");
    setAssignedTo("");
    setMaintenanceType("");
    setFacilityName("");
  };

  const handleUpdateEvent = () => {
    // const selectedFacility = facilitiesData.find(f => f.id === facility_id);
    const messageToUpdate = {
      id: selectedMessage.id,
      note,
      facility_id: facility_id !== "" ? facility_id : null,
        // building_id: building_id !== "" ? building_id : null,
        // group_id: group_id !== "" ? group_id : null,
        // unit_id: unit_id !== "" ? unit_id : null,
      assignedDate,
      assignedTo,
      maintenance_type,
      facility_name: facilitiesData.find(f => f.id === facility_id)?.name || null,
    };

    propDispatch(updateMessage(messageToUpdate));
    handleAddMessage();
  };

  const EventActions = () => {
    console.log(selectedMessage);
    if (isObjEmpty(selectedMessage)) {
      return (
        <Fragment>
          <Button className="mr-3 btn-rounded" type="submit" color="primary">
            Add
          </Button>
          <Button
            className="btn-rounded"
            color="secondary"
            type="reset"
            onClick={handleAddMessage}
            outline
          >
            Cancel
          </Button>
        </Fragment>
      );
    } else {
      return (
        <Fragment>
          <Button
            className="mr-3 btn-rounded"
            color="primary"
            onClick={handleUpdateEvent}
          >
            Update
          </Button>
          <Button
            className="btn-rounded"
            color="secondary"
            type="reset"
            onClick={handleAddMessage}
            outline
          >
            Cancel
          </Button>
        </Fragment>
      );
    }
  };

  const CloseBtn = (
    <i className="eva eva-close cursor-pointer" onClick={handleAddMessage} />
  );

  return (
    <Modal
      isOpen={open}
      toggle={handleAddMessage}
      onOpened={handleSelectedEvent}
      onClosed={handleResetInputValues}
      className="sidebar-lg"
      contentClassName="p-0"
      modalClassName="modal-slide-in event-sidebar"
    >
      <ModalHeader
        className="mb-1"
        toggle={handleAddMessage}
        close={CloseBtn}
        tag="div"
      >
        <h5 className="modal-title">
          {selectedMessage && selectedMessage.id ? "Update" : "Add"} Maintenance
          Message
        </h5>
      </ModalHeader>
      <ModalBody className="flex-grow-1 pb-sm-0 pb-3">
        <Form
          onSubmit={handleSubmit((data) => {
            if (isObjEmpty(errors)) {
              if (
                isObjEmpty(selectedMessage) ||
                (!isObjEmpty(selectedMessage) && !selectedMessage.title.length)
              ) {
                handleAddEvent();
              } else {
                handleUpdateEvent();
              }
              handleAddMessage();
            }
          })}
        >
          <FormGroup>
            <Label for="note">Note</Label>
            <Input
              id="note"
              name="note"
              placeholder="Maintenance message"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              innerRef={register({
                register: true,
                validate: (value) => value !== "",
              })}
              className={classnames({
                "is-invalid": errors.note,
                // add extended bootstrap class for show invalid field value
              })}
            />
          </FormGroup>
          <FormGroup>
            <Label for="facility_id">Facility</Label>
            <Select
              id="facility_id"
              name="facility_id"
              value={facilitiesData.find(f => f.id === facility_id) ? { value: facility_id, label: facilitiesData.find(f => f.id === facility_id).name } : null}
              options={facilitiesData.map(facility => ({
                value: facility.id,
                label: facility.name
              }))}
              onChange={option => setFacilityID(option ? option.value : "")}
              className={classnames({
                "is-invalid": errors.facility_id,
              })}
              isClearable
              placeholder="Select facility"
            />
          </FormGroup>
          {/* <FormGroup>
            <Label for="building_id">Building ID</Label>
            <Input
              id="building_id"
              name="building_id"
              placeholder="18"
              value={building_id}
              onChange={(e) => setBuildingID(e.target.value)}
              innerRef={register({
                register: true,
                validate: (value) => value !== "",
              })}
              className={classnames({
                "is-invalid": errors.building_id,
                // add extended bootstrap class for show invalid field value
              })}
            />
          </FormGroup>
          <FormGroup>
            <Label for="group_id">Group ID</Label>
            <Input
              id="group_id"
              name="group_id"
              placeholder="18"
              value={group_id}
              onChange={(e) => setGroupID(e.target.value)}
              innerRef={register({
                register: true,
                validate: (value) => value !== "",
              })}
              className={classnames({
                "is-invalid": errors.group_id,
                // add extended bootstrap class for show invalid field value
              })}
            />
          </FormGroup>
          <FormGroup>
            <Label for="unit_id">Unit ID</Label>
            <Input
              id="unit_id"
              name="unit_id"
              placeholder="18"
              value={unit_id}
              onChange={(e) => setUnitID(e.target.value)}
              innerRef={register({
                register: true,
                validate: (value) => value !== "",
              })}
              className={classnames({
                "is-invalid": errors.unit_id,
                // add extended bootstrap class for show invalid field value
              })}
            />
          </FormGroup> */}
          <FormGroup>
            <Label for="assignedDate">Assigned Date</Label>
            <Flatpickr
              required
              id="assignedDate"
              name="assignedDate"
              className="form-control"
              onChange={(date) => {
                setAssignedDate(date[0]);
              }}
              value={assignedDate}
              options={{
                enableTime: false,
                time_24hr: true,
                // dateformat: 'Y-m-d H:i'
              }}
            />
          </FormGroup>
          <FormGroup>
            <Label for="maintenance_type">Maintenance Type</Label>
            <Input
              type="select"
              id="maintenance_type"
              name="maintenance_type"
              value={maintenance_type}
              onChange={e => setMaintenanceType(e.target.value)}
              required
            >
              <option value="">Select type</option>
              <option value="monthly">Monthly</option>
              <option value="quarterly">Quarterly</option>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label for="assignedTo">Assigned To</Label>
            <Input
              id="assignedTo"
              name="assignedTo"
              placeholder="Soe Thet"
              value={assignedTo}
              onChange={(e) => setAssignedTo(e.target.value)}
              innerRef={register({
                register: true,
                validate: (value) => value !== "",
              })}
              className={classnames({
                "is-invalid": errors.assignedTo,
                // add extended bootstrap class for show invalid field value
              })}
            />
          </FormGroup>
          <FormGroup className="d-flex">
            <EventActions />
          </FormGroup>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default AddEventSidebar;
